import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('netzero_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    // Mock login - replace with actual API call
    const mockUser = { email, name: 'Muhammad Kashan', id: '1' };
    setUser(mockUser);
    localStorage.setItem('netzero_user', JSON.stringify(mockUser));
    return { success: true };
  };

  const signup = async (userData) => {
    // Mock signup - replace with actual API call
    const mockUser = { email: userData.email, name: userData.name, id: '1' };
    setUser(mockUser);
    localStorage.setItem('netzero_user', JSON.stringify(mockUser));
    return { success: true };
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('netzero_user');
  };

  const value = {
    user,
    login,
    signup,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};